export default __webpack_public_path__ + "static/media/inventory_manager.98945a89.png";